// /* Utils Initialiser */
// import { qs, qsa, addGlobalEventListener } from './utils.js'

/* eslint-disable */

/* Global Constants */

const body = document.querySelector('body')

/* Swiper Initialiser */
// Thumbnail Swiper
const thumbnailSwiper = new Swiper('#productThumbnailCarousel', {
	spaceBetween: 4,
  slidesPerView: 'auto',
  freeMode: false,
  watchSlidesProgress: true,
	slidesOffsetBefore: 20,
	slidesOffsetAfter: 20
});

// ProductCarousel
var productSwiper = new Swiper('#productCarousel', {
	direction: 'horizontal',
	freeMode: false,
	slidesPerView: 1,
	spaceBetween: 0,
	mousewheel: {
		forceToAxis: true,
		sensitivity: 0.3,
	},

	navigation: {
		nextEl: '#navigationNextProduct',
		prevEl: '#navigationPrevProduct',
	},

	thumbs: {
    swiper: thumbnailSwiper,
  },
})

/* Homepage Banner */

var homepageBanner = new Swiper('#bannerSwiper', {
	direction: 'horizontal',
	mousewheel: {
		forceToAxis: true,
		sensitivity: 0.1,
	},
	loop: true,
	autoHeight: false,
	slidesPerView: 1,
	speed: 450,
	// centeredSlides: true,
	watchSlidesProgress: true,
	watchSlidesVisibility: true,
	pagination: {
		el: '.swiper-pagination',
		clickable: true,
	},
})

var beforeAfterSwiper = new Swiper('#beforeAfterSwiper', {
	direction: 'horizontal',
	mousewheel: {
		forceToAxis: true,
	},
	effect: 'fade',
	loop: true,
	autoHeight: false,
	allowTouchMove: false,
	slidesPerView: 1,
	speed: 450,
	centeredSlides: true,
	navigation: {
		nextEl: '#navigationNext',
		prevEl: '#navigationPrev',
	},
	pagination: {
		el: '#beforeAfterPagination',
		type: 'custom',
		renderCustom: function (swiper, current, total) {
			return current + ' of ' + total
		},
	},
})

var featuredArticles = new Swiper('#featuredPostsSwiper', {
	direction: 'horizontal',
	mousewheel: {
		forceToAxis: true,
	},
	loop: false,
	spaceBetween: 16,
	slidesPerView: 1.5,
	pagination: {
		el: '#featuredPostsProgress',
		type: 'progressbar',
	},
	navigation: {
		nextEl: '#featuredPostsNext',
		prevEl: '#featuredPostsPrev',
	},
	breakpoints: {
		1024: {
			slidesPerView: 2.5,
		},
	},
})

var verticalSliderMobile = new Swiper('#mobileVerticalSlider', {
	direction: 'horizontal',
	loop: true,
	spaceBetween: 16,
	slidesPerView: 1,
	pagination: {
		el: '#mobileVerticalSliderPagination',
	},
	speed: 450,
})

var featuredUgcSliderMobile = new Swiper('#featuredUcgMobileSlider', {
	direction: 'horizontal',
	loop: false,
	slidesPerView: 1.5,
	speed: 450,
	spaceBetween: 16,
	pagination: {
		el: '#mobileFeaturedUgcPagination',
		type: 'progressbar',
	},
	breakpoints: {
		1024: {
			slidesPerView: 3,
		},
	},
})
var productBenefitsMobile = new Swiper('#productBenefitsSlider', {
	direction: 'horizontal',
	loop: false,
	slidesPerView: 1.2,
	spaceBetween: 16,
	pagination: {
		el: '#productBenefitsUgcPagination',
		type: 'progressbar',
	},
})
var featuredCollectionSlider = new Swiper('#featuredCollectionSlider', {
	direction: 'horizontal',
	loop: false,
	slidesPerView: 1.5,
	spaceBetween: 16,
	pagination: {
		el: '#featuredCollectionProgress',
		type: 'progressbar',
	},
})
var beforeAfterInner = new Swiper('#beforeAfterInnerSwiper', {
	direction: 'horizontal',
	loop: false,
	autoHeight: false,
	slidesPerView: 1,
	spaceBetween: 16,
	pagination: {
		el: '#beforeAfterProgress',
	},
})

var featuredReviews = new Swiper('#featuredReviews', {
  direction: 'horizontal',
  loop: true,
  slidesPerView: 1,
  speed: 450,
	autoplay: {
    delay: 4500,
    disableOnInteraction: false
  }
});

/* Get Closest Element */
const closest = (to, selector) => {
	let currentElement = to
	let returnElement

	while (currentElement.parentNode && !returnElement) {
		currentElement = currentElement.parentNode
		returnElement = currentElement.querySelector(selector)
	}

	return returnElement
}

/* Toggle Class (Generic) */
function toggleClass(modalName) {
	var modalActive = document.querySelector(modalName)
	modalActive.classList.toggle('active')
}

/* Update Price */
function updatePrice(form, priceQ, ogQuantity) {
	const quantity = form.value
	const priceEl = closest(form, priceQ)

	if (priceEl) {
		const price = Number(priceEl.innerHTML.slice(1))
		const currency = priceEl.innerHTML.charAt(0)
		const newPrice = ((price / ogQuantity) * quantity).toFixed(2)
		priceEl.innerHTML = currency + newPrice
	}
}

/* Change Product Quantity */
function changeQuantity(formId, quantity, priceQ, compPriceQ = false) {
	var formQ = document.querySelector(formId)
	const ogQuantity = formQ.value

	if (quantity == '+') {
		Number(formQ.value++)
	} else if (quantity == '-' && formQ.value > 1) {
		Number(formQ.value--)
	}
	updatePrice(formQ, priceQ, ogQuantity)
	if (compPriceQ) {
		updatePrice(formQ, compPriceQ, ogQuantity)
	}
}

/* Open Cart */
function cartOpen() {
	body.classList.add('js-my-cart-open')
}

function cartClose() {
	body.classList.remove('js-my-cart-open')
}

/* Check if element is in view */

const elementIsVisibleInViewport = (el, partiallyVisible = false) => {
	const { top, left, bottom, right } = el.getBoundingClientRect()
	const { innerHeight, innerWidth } = window
	return partiallyVisible
		? ((top > 0 && top < innerHeight) ||
				(bottom > 0 && bottom < innerHeight)) &&
				((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
		: top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth
}

/* Details Animator */
const details = document.querySelectorAll('details')

if (details) {
	details.forEach((targetDetail) => {
		targetDetail.addEventListener('click', function (e) {
			if (targetDetail.hasAttribute('open')) {
				// e.preventDefault()
				targetDetail.classList.add('closing')

				setTimeout(() => {
					targetDetail.removeAttribute('open')
					targetDetail.classList.remove('closing')
				}, 390)
			}
		})
	})
}

/* Orphan Remove and LSEP Removal */
var nbspSelectors = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'a', 'span']
var nbspWordMin = 10 //Minimum words within parent tag to activate script

// nbspSelectors.forEach(function (selector) {
//   var nbspElements = document.querySelectorAll(selector)
//   nbspElements.forEach(function (element) {
//     element.innerHTML = element.innerHTML.replace(/\u2028/g, '')
//     element.innerHTML = element.innerHTML.replace(/&#8232;/g, '')
//     var wordCount = element.innerHTML.split(' ').length
//     if (wordCount >= nbspWordMin) {
//       element.innerHTML = element.innerHTML.replace(/ ([^ ]*)$/, '&nbsp;$1')
//     }
//   })
// })

/* Lazy Load Initialiser */
var lazyLoadInstance = new LazyLoad({})

/* Close Announcement Bar */
const announcementCloseBtn = document.querySelector('#closeAnnouncementBar');
if (window.sessionStorage.getItem('fjorAnnouncementBarVisible') === 'false') {
  body.classList.add('announcement-closed');
}

announcementCloseBtn.addEventListener('click', (e) => {
  e.currentTarget.parentElement.classList.add('hidden');
  window.sessionStorage.setItem('fjorAnnouncementBarVisible', false);
  body.classList.add('announcement-closed');
});

/* Navigation */

const navigation = document.querySelector('#navigation')
const header = document.querySelector('.header')

const menuItems = Array.from(document.querySelectorAll('#headerMenuItem'))
const navItems = Array.from(document.querySelectorAll('#navMenuItem'))
const navBg = document.querySelector('#navigationBg')
const shopSection = document.querySelector('#Shop')
const childLinks = document.querySelectorAll('.navigation__child-link')
const childImages = document.querySelectorAll('.navigation__image')

menuItems.forEach((item) => {
	item.addEventListener('mouseenter', (e) => {
		const navItem = e.currentTarget.dataset.navItem

		if (navItem == 'Shop') {
			shopSection.classList.add('active');
		} else {
			shopSection.classList.remove('active');
		}

		const childLinks = document.querySelector(
			`#navChildMenu[data-nav-item="${navItem}"]`
		)

		menuItems.forEach((menuItem) => menuItem.classList.remove('active'));

		const activeNavLink = menuItems.find(
			(item) => item.dataset.navItem == navItem
		)

		const activeNavItem = document.querySelector('#navChildMenu.active')

		if (activeNavItem) {
			activeNavItem.classList.remove('active')
		}
		
		childLinks.classList.add('active')
		activeNavLink.classList.add('active')
		navigation.classList.add('active')
		navBg.classList.add('active')

	})
})

childLinks.forEach(link => {
	link.addEventListener('mouseenter', (e) => {
		const navItem = link.getAttribute('data-nav-item');
		const activeImage = document.querySelector(`#image-${CSS.escape(navItem)}`);

		childImages.forEach(img => img.classList.remove('active'));

		if (activeImage) {
			activeImage.classList.add('active');
		}
	});
});

navigation.addEventListener('mouseleave', (e) => {
	navigation.classList.remove('active')
	navBg.classList.remove('active')
	menuItems.forEach((menuItem) => menuItem.classList.remove('active'));

	document.querySelector('#navMenuItem.active').classList.remove('active')
	document.querySelector('#navChildMenu.active').classList.remove('active')
	childImages.forEach(img => img.classList.remove('active'));
	childImages[0]?.classList.add('active');
})



/* Mobile Navigation */

const mobileNavigation = document.querySelector('#mobileNavigation')
const mobileHamburger = document.querySelector('#mobileHamburger')

mobileHamburger.addEventListener('click', () => {
	mobileNavigation.classList.toggle('active')

	mobileHamburger.classList.toggle('active')
	header.classList.toggle('active')
})

const mobileNavParents = Array.from(
	document.querySelectorAll('#mobileNavigationParent')
)

mobileNavParents.forEach((parent) => {
	parent.addEventListener('click', () => {
		parent.classList.toggle('active')

		mobileNavParents
			.filter((item) => item != parent)
			.forEach((nav) => nav.classList.remove('active'))
	})
})

const mobileNavBackButton = Array.from(
	document.querySelectorAll('#mobileBackButton')
)

mobileNavBackButton.forEach((button) => {
	button.addEventListener('click', () => {
		console.log('clicked')
		mobileNavParents.forEach((parent) => parent.classList.remove('active'));
	})
})

/* Vertical Slider */

const slideImages = Array.from(document.querySelectorAll('#verticalSliderImg'))
const slideTitles = Array.from(
	document.querySelectorAll('#verticalSliderTitle')
)

if (slideImages.length > 0) {
	document.addEventListener('scroll', () => {
		const activeTitle = document.querySelector('#verticalSliderTitle.active')
		const title = activeTitle.dataset.title
		const inactiveSlides = slideImages.filter(
			(img) => img.dataset.title != title
		)
		const activeBody = document.querySelector('#verticalSliderBody.active')

		inactiveSlides.forEach((img) => {
			if (elementIsVisibleInViewport(img)) {
				const newTitle = img.dataset.title

				activeBody.classList.remove('active')
				activeTitle.classList.remove('active')

				document
					.querySelector(`#verticalSliderTitle[data-title="${newTitle}"]`)
					.classList.add('active')
				document
					.querySelector(`#verticalSliderBody[data-title="${newTitle}"]`)
					.classList.add('active')
			}
		})
	})
}

slideTitles.forEach((title) => {
	title.addEventListener('click', () => {
		const item = title.dataset.title

		const image = document.querySelector(
			`#verticalSliderImg[data-title="${item}"]`
		)

		image.scrollIntoView({
			behavior: 'smooth',
			block: 'center',
		})
	})
})

/* Hotspots */

const hotspots = Array.from(document.querySelectorAll('#mediaHotspot'))
const hotspotBodys = Array.from(document.querySelectorAll('#mediaHotspotBody'))

hotspots.forEach((hotspot, i) => {
	// Hover
	hotspot.addEventListener('mouseenter', () => {
		const activeHotspot = document.querySelector('#mediaHotspot.active')
		const activeBody = document.querySelector('#mediaHotspotBody.active')
		if (activeBody) {
			activeBody.classList.remove('active')
		}
		activeHotspot.classList.remove('active')

		hotspot.classList.add('active')
		hotspotBodys[i].classList.add('active')
	})
	// Click
	hotspot.addEventListener('click', () => {
		const activeHotspot = document.querySelector('#mediaHotspot.active')
		const activeBody = document.querySelector('#mediaHotspotBody.active')
		if (activeBody) {
			activeBody.classList.remove('active')
		}
		activeHotspot.classList.remove('active')

		hotspot.classList.add('active')
		hotspotBodys[i].classList.add('active')
	})
})

/* newsletter popup gsap */

/* Sticky Atc */

const stickyAtc = document.querySelector('#stickyAtc')

if (stickyAtc) {
	ScrollTrigger.create({
		start: 'top -160',
		end: document.body.scrollHeight - 440 + ' bottom',
		toggleClass: {
			className: 'active',
			targets: stickyAtc,
		},
	})
}

/* Shopify Liquid Ajax Cart */
const atcButtons = document.querySelectorAll('[data-cart-btn]')
if (atcButtons.length > 0) {
	liquidAjaxCart.subscribeToCartAjaxRequests((state, subscribeToResult) => {
		const btnState = atcButtons[0].innerHTML

    if (state.requestType == 'add') {
      let btnInner = ""
      const form = state.info.initiator
      const btn = form.querySelector('[data-cart-btn]')
    
      if (btn) {
        btnInner = btn.innerHTML
        btn.innerHTML = 'Adding'
      }
    
      subscribeToResult((state) => {
        if (state.responseData.ok) {
          cartOpen()
        }
    
        if (btn) {
          setTimeout(() => {
            btn.innerHTML = btnInner
          }, 300)
        }
    
        // Restricting Free bag to one
        const { cart } = liquidAjaxCart.getCartState()
        if (freeBagId) {
          const hasBag = cart.items.some((item) => item.id == freeBagId)
          if (hasBag) {
            liquidAjaxCart.cartRequestChange({
              id: freeBagId.toString(),
              quantity: 1,
            })
          }
        }
      })
    }

		if ((state.requestType = 'change')) {
			subscribeToResult((state) => {
				if (state.responseData.ok) {
					const { cart } = liquidAjaxCart.getCartState()
					if (freeBagId) {
						const cartWithoutBag = cart.items.filter(
							(item) => item.id != freeBagId
						)
						const noSubscription = cartWithoutBag.every(
							(item) => item.selling_plan_allocation == undefined
						)
						const hasBag = cart.items.some((item) => item.id == freeBagId)
						if (noSubscription && hasBag) {
							liquidAjaxCart.cartRequestChange({
								id: freeBagId.toString(),
								quantity: 0,
							})
						}
					}
				}
			})
		}
	})
}

/* enterview */
/* Load video on enter */

const llVideos = document.querySelectorAll('.video-ll')

if (llVideos.length > 0) {
	enterView({
		selector: '.video-ll',
		enter: function (el) {
			el.load()
			el.play()
		},
		offset: 0.1,
	})
}

/* dropdown info */

const infoDropdowns = document.querySelectorAll('.dropdown-info')

infoDropdowns.forEach((el) => {
	const headingContainer = el.querySelector('.dropdown-info__selected-heading')
	const headingInner = el.querySelector(
		'.dropdown-info__selected-heading-inner'
	)
	const optionContainer = el.querySelector('.dropdown-info__option-container')
	const headingOptions = el.querySelectorAll('.dropdown-info__option')
	headingContainer.addEventListener('mouseenter', (e) => {
		optionContainer.classList.add('active')
	})

	const bodyContainer = el.querySelector('.dropdown-info__body-container')
	const body = el.querySelector('.dropdown-info__body.active')

	bodyContainer.style.height = `${body.offsetHeight}px`

	headingOptions.forEach((heading) => {
		heading.addEventListener('click', (e) => {
			const index = heading.dataset.index
			const title = heading.innerHTML
			const oldHeading = el.querySelector('.dropdown-info__option.active')
			const newBody = el.querySelector(
				`.dropdown-info__body[data-index="${index}"]`
			)
			const oldBody = el.querySelector(`.dropdown-info__body.active`)

			const posTop = ((index - 1) * 32 + 10) * -1

			headingInner.innerHTML = title
			optionContainer.classList.remove('active')

			oldHeading.classList.remove('active')
			heading.classList.add('active')

			oldBody.classList.remove('active')
			newBody.classList.add('active')

			bodyContainer.style.height = `${newBody.offsetHeight}px`

			setTimeout(() => {
				optionContainer.style.top = `${posTop}px`
			}, 400)
		})
	})
})
